module.exports = __webpack_public_path__ + "img/pad_img_h5.72ad0302.png";